import { render } from "./Treneri.vue?vue&type=template&id=17452e90&scoped=true"
import script from "./Treneri.vue?vue&type=script&lang=js"
export * from "./Treneri.vue?vue&type=script&lang=js"

import "./Treneri.vue?vue&type=style&index=0&id=17452e90&scoped=true&lang=css"

import exportComponent from "E:\\Faks Projekti\\ssa_sajt\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17452e90"]])

export default __exports__